/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Modelo {
  constructor () {
    this.modelo_id = uuidV4()
    this.descr = ''
    this.marca_id = ''
  }
}
